import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../public/fonts/SFPro/perfectly-nineties-regular.woff2%22,%22variable%22:%22--font-perfectly-nineties%22,%22display%22:%22swap%22,%22preload%22:false}],%22variableName%22:%22perfectlyNineties%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'perfectlyNineties', 'perfectlyNineties Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
